import { Spinner, Progress } from '@treasuryspring/spring-ui';
import { useEffect } from 'react';

import tsLogo from '@/assets/logo.svg';
import { useAppStore } from '@/stores/useAppStore';

interface LoadingProps {
  logo?: boolean;
  bar?: boolean;
}

export default function Loading({ logo, bar }: LoadingProps) {
  const { progress, setProgress } = useAppStore();

  useEffect(() => {
    setProgress(10);
    const interval = setInterval(() => {
      const { progress: prev } = useAppStore.getState();
      const newProgress = Math.min(prev + (100 - 0.25 * prev) / prev, 99);
      useAppStore.getState().setProgress(newProgress);
    }, 100);
    return () => clearInterval(interval);
  }, [setProgress]);

  return (
    <div className="gap-xl absolute top-1/2 left-1/2 flex w-[16rem] -translate-1/2 flex-col items-center justify-center">
      {logo && <img src={tsLogo} alt="Treasury Spring" />}
      {bar ? <Progress value={progress} animation /> : <Spinner size="large" />}
    </div>
  );
}
